var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rb-display-controls"},[_c('span',[_vm._v(_vm._s(_vm.label))]),_c('button',{class:[
      'rb-btn-display rb-btn-table',
      { 'rb-active': _vm.displayMode === 'table' },
    ],attrs:{"id":"btn-display-list","aria-label":"Display as List"},on:{"click":function($event){$event.preventDefault();return _vm.notifyDisplayMode($event, 'table')}}},[_c('icon-list')],1),_c('button',{class:[
      'rb-btn-display rb-btn-grid',
      { 'rb-active': _vm.displayMode === 'grid' },
    ],attrs:{"id":"btn-display-grid","aria-label":"Display as Grid"},on:{"click":function($event){$event.preventDefault();return _vm.notifyDisplayMode($event, 'grid')}}},[_c('icon-grid')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }